<template>
  <v-dialog v-model="model" max-width="565" content-class="eru-dialog">
    <v-card class="eru modal-card">
      <v-btn icon class="close-btn" @click.stop="close"><v-icon>mdi-close</v-icon></v-btn>

      <h2 class="modal-title">Редактировать резерв</h2>

      <div class="modal-body">
        <div class="field">
          <div class="field__label">Наименование</div>
          <v-text-field
            v-model="form.title"
            outlined
            dense
            hide-details
            class="field__input"
            placeholder="Например: Резерв на октябрь"
          />
        </div>

        <div class="field field--checkbox">
          <div class="checkbox-wrap">
            <v-checkbox
              v-model="form.autorenew"
              hide-details
              :ripple="false"
              class="checkbox"
              color="#4B5EFF"
              label="Автопродление аренды"
            />
            <v-tooltip bottom max-width="300">
              <template #activator="{ on, attrs }">
                <v-icon small class="hint-icon" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
              </template>
              <span>При окончании аренды продлевать ещё на 30 дней</span>
            </v-tooltip>
          </div>
        </div>

        <v-btn class="primary-btn" block height="48" @click="save">Сохранить</v-btn>
        <v-btn text class="cancel-btn mt-2" @click="close">Отмена</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditReserveUserModal',
  props: {
    value: { type: Boolean, default: false },
    reserve: { type: Object, default: () => ({ id:null, title:'', autorenew:false }) }
  },
  data(){ return {
    model: this.value,
    form: { id: this.reserve?.id || null, title: this.reserve?.title || '', autorenew: !!this.reserve?.autorenew }
  }},
  watch:{
    value(v){ this.model = v },
    model(v){ this.$emit('input', v) },
    reserve:{
      handler(v){
        this.form = { id: v?.id || null, title: v?.title || '', autorenew: !!v?.autorenew }
      }, deep:true, immediate:true
    }
  },
  methods:{
    close(){ this.model = false },
    save(){ this.$emit('save', { ...this.form }); this.model = false }
  }
}
</script>

<style scoped>
.eru{
  --text:#2B2D33; --muted:#6F7075; --line:#D9DADE; --accent:#4B5EFF;
}
.eru-dialog{ align-items:flex-start; }
.modal-card{ position:relative; padding:28px 28px 22px; border-radius:8px; box-shadow:0 18px 50px rgba(0,0,0,.14); }
.close-btn{ position:absolute; top:10px; right:10px; min-width:36px; height:36px; }
.modal-title{ margin:6px 0 12px; text-align:center; font:800 24px/1.2 Manrope,system-ui,sans-serif; color:var(--text); }
.modal-body{ padding-top:8px; }

.field{ margin-bottom:18px; }
.field__label{ font:700 15px/1.25 Manrope,sans-serif; color:var(--text); margin-bottom:6px; }
.field__input :deep(.v-input__slot){ min-height:40px; border-radius:8px; border-color:var(--line)!important; }
.field__input :deep(.v-input__slot:hover),
.field__input :deep(.v-input--is-focused .v-input__slot){ border-color:var(--accent)!important; }

.field--checkbox{ margin:6px 0 14px; }
.checkbox-wrap{ display:flex; align-items:center; }
.checkbox :deep(.v-input__slot){ margin:0; }
.checkbox :deep(.v-label){ font:600 15px/1.2 Manrope,sans-serif; color:var(--text); }
.hint-icon{ margin-left:8px; color:#9EA0A6; }

.primary-btn{
  background:#4B5EFF!important;
  color:#fff!important;
  font:800 16px/1.1 Manrope,sans-serif;
  border-radius:8px;
  text-transform:none;
  letter-spacing:0;
}
.cancel-btn{ color:var(--muted)!important; font:700 14px/1.2 Manrope,sans-serif; }
</style>
